
const checkDistance = (m) => (
  m/1000 >= 1 ? `${Math.trunc(m/1000)}km`: `${m}m`
)

export default checkDistance;